import React from 'react';

const Footer = () => {
    return (
        <div className="footer pt-5">
            <p className="text-muted"> &copy; 2022 – All Right Reserved by Ariful Haque
</p>
        </div>
    );
};

export default Footer;